var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "block lazyload",
    attrs: {
      "data-src": _vm.src,
      "data-srcset": _vm.srcset,
      "data-sizes": "auto",
      alt: _vm.alt,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }